import {Component} from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
//import AppBar from 'material-ui/AppBar';
//import {Tabs, Tab} from 'material-ui/Tabs';
import {AppBackground, FullSize, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import {withStyles} from '@material-ui/core/styles';
//import BiomassView  from  './BiomassView';
import PropTypes from 'prop-types';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import image1 from '../../images/IMG_1.JPG';
import image2 from '../../images/IMG_2.JPG';
import image3 from '../../images/IMG_3.JPG';
import image4 from '../../images/IMG_4.JPG';
import image5 from '../../images/IMG_5.JPG';


import VehicleOwnerConfiguration2 from "./VehicleOwnerConfiguration2";
import SimpleSlider from "./SimpleSlider";
import ContactUs from "./ContactUs";
import Login from "./Login";
import Logout from "./Logout";
//import VerticalTabs from "./VerticalTabs";
//import {loadLoginData, saveLoginData, updateLoginData, login, logout, handleAuthentication, isAuthenticatedAction,updateUserProfileAction} from "../../redux/modules/login";
import {
    handleAuthenticationAction,
    isAuthenticatedAction,
    loginAction,
    updateUserProfileAction
} from "../../redux/modules/login";
import TowCompanyMainPage from "./TowCompanyMainPage";
import PropertyManagerMainPage from "./PropertyManagerMainPage";



const Styles = {
    root: Object.assign({},  FullSize, AppBackground, MediumFont, TextColor),
    tabDiv: {width: "90%", float: "right",  background:"red"},
    barButtonDiv: {marginTop: 10},
    imgLabel: {marginTop: -25, marginRight: 10, color: 'white', textAlign: 'right'},
    navLabel: Object.assign({margin: 10, width: '90%'}, MediumFont, TextColor),
    paneTable: {width: '100%', height: '100%'},
    leftPane: {borderRight: '2px solid white', verticalAlign: 'top', margin: 5},
    rightPane: {verticalAlign: 'top'},
    unselected: {cursor: 'pointer', width: "94%", marginTop: 5, marginLeft: 5},
    selected: Object.assign({width: "94%", marginTop: 5, marginLeft: 5}, ThinBorder)
}

const tileData = [
    {
        img: image1,
        title: 'Image2',
        author: 'author',
        featured: true,
    },
    {
        img: image2,
        title: 'Image2',
        author: 'author',
        featured: true,
    },
    {
        img: image3,
        title: 'Image3',
        author: 'author',
        featured: true,
    },
    {
        img: image4,
        title: 'Image4',
        author: 'author',
        featured: true,
    },
    {
        img: image5,
        title: 'Image5',
        author: 'author',
        featured: true,
    },
]

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding:1*0,}}>
    {props.children}
</Typography>
);
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        backgroundColor:theme.palette.background.paper,
    },
});

class AppView extends Component {

    state = {
        value: 0,
    };

    /*

    login() {
        this.props.auth.login();
    }

    logout() {
        this.props.auth.logout();
    }

    getProfile() {
        this.props.auth.getProfile();
    }

    */

   /*  componentDidMount() {
        const { renewSession} = this.props.auth;
        this.props.auth.goHome= this.goHomeClickHere;
        if (localStorage.getItem('isLoggedIn') === 'true') {
            renewSession();
        }

    }*/

    componentDidMount() {
        const { isAuthenticatedAction ,updateUserProfile, updateAuth,updateUserProfileAction} = this.props;
        isAuthenticatedAction(this.props.loginData.expiresAt);
        updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
        //updateAuth();
        window.scrollTo(0, 0);
        console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;
        

    }

    handleChange = (event, value) => {
        const { isAuthenticated } = this.props;
        //isAuthenticated();
        let updateValue = 0;
        if( !this.props.isAuthenticatedBool && value != 0){
            updateValue = value+3;
       }else{
            updateValue = value;
        }
        this.setState({ value : updateValue});
    };


    constructor(props) {
        super(props);
        this.towAgentClickHere = this.towAgentClickHere.bind(this);
        this.vehicleOwnerClickHere =this.vehicleOwnerClickHere.bind(this);
        this.goHomeClickHere =this.goHomeClickHere.bind(this);
        this.gimeUserProfile =this.gimeUserProfile.bind(this);
        

    }


    towAgentClickHere(){
        //alert("was called in AppView") ;
        this.setState({value:2});
    }

    vehicleOwnerClickHere(){
        //alert("was called in AppView") ;
        this.setState({value:1});
    }

    goHomeClickHere(){
        //alert("was called in AppView") ;
        this.setState({value:0});
    }

    gimeUserProfile(){
        let returnString ="not defined";
        let returnString2 ="not defined 2";

        /*if(this.props.auth.userProfile !== undefined){
            returnString2= this.props.auth.userProfile.nickname;
        }

        if(this.props.userProfile !== undefined){
            returnString= this.props.userProfile.sub;
        } */

        if(this.props.userProfile !== undefined){
            returnString2= this.props.userProfile.nickname;
        }

        if(this.props.userProfile !== undefined){
            returnString= this.props.userProfile.sub;
        }

        return returnString+"+---"+ returnString2;
    }

    render() {
        // Initialize tabs for the horizontal app bar
        // Initialize tabs for the horizontal app bar
        //let mainTabs =  this.getTheTabs();
        const { isAuthenticated } = this.props;


        var divStyle = {
            padding: 10,
            margin: 10,
            color: 'white',
            backgroundColor: '#000000',
            height: '100%',
            width: '100%',
            backgroundSize: 'contain',
            //backgroundSize: 'cover',
            backgroundRepeat:'no-repeat',
            //backgroundImage: 'url(' + imgUrl + ')',
            //backgroundImage:"url('../../images/IMG_2.JPG')",

            backgroundImage: 'url(/static/images/IMG_2.JPG)',
            //backgroud:"url('../../images/IMG_2.JPG')",
            WebkitTransition: 'all', // note the capital 'W' here
            msTransition: 'all' // 'ms' is the only lowercase vendor prefix
        };



        const { classes } = this.props;
        const { value } = this.state;
        const dudUrl = 'SimpleSlider.city';
        //let authFlag = isAuthenticated();
        return (
            <div className={classes.root}>
         
            <AppBar position="relative"  style={{backgroundColor:'#FFFFFF', color:'black'}}>
                    <Tabs value={value} onChange={this.handleChange}>
                        <Tab label="Home" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}}/>
                        {this.props.isAuthenticatedBool && (this.props.clientType === 'vehicleOwner') && (<Tab label="Vehicle Owner" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}}/>  )}
                        {this.props.isAuthenticatedBool && (this.props.clientType ==='towCompany') && (<Tab label="Tow Company" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}}/> )}
                        {this.props.isAuthenticatedBool && (this.props.clientType ==='propertyManager') && (<Tab label="Property Manager" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}}/> )}
                        {this.props.isAuthenticatedBool && (<Tab label="Logout" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}} /> )}
                        {this.props.isAuthenticatedBool && (<Tab label="Contact Us" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}}/> )}
                        {!this.props.isAuthenticatedBool && (<Tab label="Login/Signup" href="#basic-tabs"  style={{textTransform:"none", fontSize: '18px'}}/> )}
                        {!this.props.isAuthenticatedBool && (<Tab label="Contact Us" href="#basic-tabs" style={{textTransform:"none", fontSize: '18px'}} /> )}

                    </Tabs>
                </AppBar>

                    {value === 0 && <TabContainer><SimpleSlider towAgentConfig={this.towAgentClickHere}   vehicleOwnerConfig={this.vehicleOwnerClickHere} ></SimpleSlider> </TabContainer>}
                    {value === 1 &&  (this.props.clientType === 'vehicleOwner') && <TabContainer><VehicleOwnerConfiguration2></VehicleOwnerConfiguration2></TabContainer>}
                    {value === 1 &&  (this.props.clientType === 'towCompany') && <TabContainer><TowCompanyMainPage></TowCompanyMainPage></TabContainer>}
                    {value === 1 &&  (this.props.clientType === 'propertyManager') && <TabContainer><PropertyManagerMainPage></PropertyManagerMainPage></TabContainer>}
                    {value === 2 &&  <TabContainer><Logout></Logout></TabContainer>}
                    {value === 3 &&   <TabContainer><ContactUs> </ContactUs></TabContainer>}
                    {value === 4 &&  <TabContainer><Login></Login></TabContainer>}
                    {value === 5 &&  <TabContainer><ContactUs> </ContactUs></TabContainer>}


            </div>



        );

    }


};

    AppView.propTypes = {
        classes: PropTypes.object.isRequired,
    };
const stylessample = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },

    /*divItem: {
        width: 100,
        height: 150,

        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        //transform: 'translateZ(0)',
    },*/
    gridList: {
        width: 500,
        height: 450,
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    titleBar: {
        background:
        'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
        'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'white',
    },
});

/*const mapStateToProps = state => {
    let props = {
        appState: state.appState,
        viewState: state.viewState
    };

    return (props);
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}; */

const mapStateToProps = (state) => {
    return {
        isAuthenticatedBool: state.login.isAuthenticatedBool,
        userProfile: state.login.userProfile,
        loginData:state.login.loginData,
        auth:state.login.loginData,
        clientType:state.login.clientType,
        //CompanyDeleteResponse:state.account.deleteCompanyResp,
        //CompanySaveResponse:state.account.saveCompanyResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        //errorCMsg:state.account.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loginAction:loginAction,
        handleAuthenticationAction:handleAuthenticationAction,
        isAuthenticatedAction:isAuthenticatedAction,
        updateUserProfileAction:updateUserProfileAction,
        //updateAuth:updateAuth,

    }, dispatch);
};

//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AppView));
